/**
 * Screen Wake Lock
 * 키오스크 화면이 떠있는 동안 기기 화면이 꺼지지 않도록 유지한다.
 * - 페이지가 숨겨지면(탭 전환, 홈 이동 등) 브라우저가 자동으로 해제하므로
 *   visibilitychange 시 다시 requestWakeLock()을 호출해야 한다.
 * - 배터리 절약 모드 등으로 요청이 거부될 수 있으므로 실패는 로그만 남긴다.
 */
let wakeLock = null

export function isWakeLockSupported () {
  return typeof navigator !== 'undefined' && 'wakeLock' in navigator
}

export async function requestWakeLock () {
  if (!isWakeLockSupported()) {
    console.debug('wakeLock not supported')
    return null
  }
  // 이미 활성화된 lock이 있으면 재요청하지 않음
  // (sentinel.released 속성은 Chrome 87+ 에서만 제공되므로 release 이벤트로 직접 추적)
  if (wakeLock) {
    return wakeLock
  }
  // 문서가 보이지 않는 상태에서는 요청이 거부되므로 생략
  if (document.visibilityState !== 'visible') {
    return null
  }
  try {
    wakeLock = await navigator.wakeLock.request('screen')
    wakeLock.addEventListener('release', () => {
      console.debug('wakeLock released---', new Date())
      wakeLock = null
    })
    console.debug('wakeLock acquired---', new Date())
    return wakeLock
  } catch (e) {
    console.warn('wakeLock request failed---', e.name, e.message)
    wakeLock = null
    return null
  }
}

export async function releaseWakeLock () {
  if (wakeLock) {
    await wakeLock.release()
  }
  wakeLock = null
}
